import React, { useEffect, useRef } from "react";
import Links from "./Links";
import ChevronRightIcon from "../../icons/ChevronRightIcon";
import { useNavigate } from "react-router-dom";

export function GroupOfLinks({
    group,
    name,
    submenu,
    setSubmenu,
    onClose,
    hasNoSubmenus,
    path,
}) {
    const navigate = useNavigate();

    const submenuName = "submenu-" + name;
    const prevSubmenu = useRef(submenu);
    useEffect(() => {
        if (hasNoSubmenus) return;

        if (submenu === submenuName || prevSubmenu.current === submenuName) {
            document
                .querySelector("#" + submenuName)
                .classList.toggle("hidden");
            document
                .querySelector("#arrow-" + name)
                .classList.toggle("rotate-90");
        }
        prevSubmenu.current = submenu;
    }, [submenu]);

    return (
        <div key={name} style={{ transition: `max-height 0.2s ease-out` }}>
            <div
                className="mt-3 flex cursor-pointer items-center rounded-md p-2.5 px-4 duration-300 hover:bg-blue-200"
                data-te-collapse-item
                onClick={() => {
                    if (hasNoSubmenus) {
                        setSubmenu(submenuName);

                        navigate(`/my/${path}`);
                    } else {
                        setSubmenu((prevSubmenu) => {
                            return prevSubmenu === submenuName
                                ? ""
                                : submenuName;
                        });
                    }
                }}
            >
                <i className="bi bi-chat-left-text-fill"></i>
                <div className="flex w-full items-center justify-between">
                    <p
                        className={`leading-1 ml-4 flex ${
                            submenu === submenuName
                                ? "font-bold text-navy-700 dark:text-white"
                                : "font-medium text-gray-700"
                        }`}
                    >
                        {name}
                    </p>

                    {!hasNoSubmenus && (
                        <span className="rotate-0 text-sm" id={"arrow-" + name}>
                            <ChevronRightIcon />
                        </span>
                    )}
                </div>
            </div>

            {!hasNoSubmenus && (
                <div
                    className="mx-auto mt-2 hidden w-4/5 text-left text-sm font-bold text-gray-200"
                    id={submenuName}
                >
                    <Links routes={group} closeSidebar={onClose} />
                </div>
            )}
        </div>
    );
}

export default GroupOfLinks;
